import type { LifeEvent } from '../../types/onelife.ts';

export const ELDERLY_EVENTS: LifeEvent[] = [
  {
    "id": "eld_01_golden_jubilee",
    "stageKey": "elderly",
    "age": 76,
    "titleVi": "Kim Khánh 50 Năm Bí Tích Hôn Phối",
    "descriptionVi": "Nửa thế kỷ gắn bó son sắt, hai vợ chồng cùng con cháu tứ đại tề tựu nơi thánh đường dâng Thánh Lễ Tạ Ơn Kim Khánh Bí Tích Hôn Phối.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "eld_01_a",
        "textVi": "Cùng nắm tay nhau nhắc lại lời đoan hứa trong Bí Tích Hôn Phối, tạ ơn Chúa vì 50 năm thủy chung",
        "outcomeTextVi": "Một thiên tình sử đức tin đẹp như huyền thoại, cả giáo xứ đứng dậy vỗ tay chúc tụng trong nước mắt xúc động.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": -10,
        "intellectDelta": 15,
        "relationsDelta": 45,
        "addVirtue": "Sống trọn vẹn 50 năm trung kiên thánh thiện trong ân sủng Bí Tích Hôn Phối",
        "unlockAchievement": "Kim Khánh Hôn Phối Trọn Đời"
      },
      {
        "id": "eld_01_b",
        "textVi": "Dâng toàn bộ tiền mừng làm quỹ học bổng cho các em nhỏ mồ côi",
        "outcomeTextVi": "Nghĩa cử bác ái tỏa hương thơm ngát cho muôn thế hệ cháu con noi theo.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": -25,
        "intellectDelta": 15,
        "relationsDelta": 40
      }
    ]
  },
  {
    "id": "eld_02_golden_wedding_anniv",
    "stageKey": "elderly",
    "age": 76,
    "titleVi": "Kỷ Niệm Đám Cưới Vàng 50 Năm",
    "descriptionVi": "Tiệc mừng 50 năm ngày cưới ngập tràn tiếng cười của bốn thế hệ con cháu tề tựu đông đủ.",
    "category": "love",
    "choices": [
      {
        "id": "eld_02_a",
        "textVi": "Cùng cắt bánh cưới và nhìn sâu vào mắt người bạn đời với lòng biết ơn khôn xiết",
        "outcomeTextVi": "Tình nghĩa vợ chồng già như ngọc quý mài dũa qua nửa thế kỷ giông bão.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": -15,
        "intellectDelta": 10,
        "relationsDelta": 45
      },
      {
        "id": "eld_02_b",
        "textVi": "Kể cho con cháu nghe những bài học giữ gìn hạnh phúc gia đình",
        "outcomeTextVi": "Những lời răn dạy thấm đượm tình thương trở thành gia bảo vô giá.",
        "healthDelta": 5,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 40,
        "addVirtue": "Dạy con cháu bí quyết giữ gìn gia đạo bình an, kính trên nhường dưới"
      }
    ]
  },
  {
    "id": "eld_03_morning_rosary",
    "stageKey": "elderly",
    "age": 63,
    "titleVi": "Chuỗi Hạt Mân Côi Mỗi Sớm Mai",
    "descriptionVi": "Mỗi buổi sáng sớm khi trời còn mờ sương, bạn lần chuỗi hạt Mân Côi cầu nguyện cho thế giới và con cháu.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "eld_03_a",
        "textVi": "Dâng từng hạt kinh Mân Côi cầu bình an cho gia đình và các linh hồn nơi luyện ngục",
        "outcomeTextVi": "Tâm hồn bạn lắng đọng bình an tuyệt đối, gương mặt hiền từ sáng ngời niềm hy vọng.",
        "healthDelta": 15,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 30,
        "addVirtue": "Kiên trì lần chuỗi Mân Côi mỗi ngày kết hợp cùng Mẹ Maria"
      },
      {
        "id": "eld_03_b",
        "textVi": "Tham gia hội kinh Mân Côi giáo xóm đọc kinh luân phiên các gia đình",
        "outcomeTextVi": "Xóm đạo rộn rã lời kinh tối, gắn kết tình làng nghĩa xóm bền chặt.",
        "healthDelta": 10,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "eld_04_grandchild_tutoring",
    "stageKey": "elderly",
    "age": 65,
    "titleVi": "Dạy Cháu Học Chữ & Đạo Làm Người",
    "descriptionVi": "Buổi chiều mát, bạn ngồi dưới bóng cây khế dạy cháu đọc thơ, viết chữ và học lễ nghĩa.",
    "category": "family",
    "choices": [
      {
        "id": "eld_04_a",
        "textVi": "Uốn nắn từng nét chữ, kể chuyện gương sáng danh nhân cho cháu nghe",
        "outcomeTextVi": "Cháu chăm ngoan học giỏi, luôn quấn quýt bên ông/bà không rời.",
        "healthDelta": 15,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 40,
        "addVirtue": "Tận tình dạy dỗ cháu chắt đạo lý làm người và lòng hiếu thảo"
      },
      {
        "id": "eld_04_b",
        "textVi": "Làm những món đồ chơi thủ công truyền thống tặng cháu",
        "outcomeTextVi": "Kỷ niệm tuổi thơ tuyệt đẹp bên ông bà sẽ theo cháu suốt cuộc đời.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "eld_05_parish_senior_council",
    "stageKey": "elderly",
    "age": 68,
    "titleVi": "Hội Các Bô Lão Giáo Xứ / Làng Xóm",
    "descriptionVi": "Các bậc cao niên trong làng/giáo xứ họp mặt bàn việc giữ gìn phong tục và hòa giải tranh chấp.",
    "category": "society",
    "choices": [
      {
        "id": "eld_05_a",
        "textVi": "Dùng uy tín và lời lẽ thấu tình đạt lý hòa giải êm đẹp mâu thuẫn láng giềng",
        "outcomeTextVi": "Hai bên bắt tay làm hòa, cả làng kính trọng người bô lão đức độ, công tâm.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 45,
        "addVirtue": "Người kiến tạo hòa bình, đem lại sự êm ấm cho xóm làng",
        "unlockAchievement": "Bậc Bô Lão Đức Cao Vọng Trọng"
      },
      {
        "id": "eld_05_b",
        "textVi": "Đề xuất phong trào khuyến học và giúp đỡ người già neo đơn không nơi nương tựa",
        "outcomeTextVi": "Xóm làng trở thành hình mẫu về văn hóa và lòng nhân ái.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": -10,
        "intellectDelta": 20,
        "relationsDelta": 40
      }
    ]
  },
  {
    "id": "eld_06_seventy_milestone",
    "stageKey": "elderly",
    "age": 70,
    "titleVi": "Thất Thập Cổ Lai Hy — Mừng Thọ 70 Tuổi",
    "descriptionVi": "Tròn 70 tuổi — xưa nay hiếm, con cháu quây quần dâng lễ mừng thọ trong niềm hân hoan.",
    "category": "family",
    "choices": [
      {
        "id": "eld_06_a",
        "textVi": "Mỉm cười chúc lành cho từng đứa con, đứa cháu và khuyên răn sống lương thiện",
        "outcomeTextVi": "Lời chúc lành thiêng liêng nâng đỡ bước đường tương lai của cả gia tộc.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 45,
        "addVirtue": "Tâm hồn bao dung, luôn chúc lành và che chở cho đàn con cháu"
      },
      {
        "id": "eld_06_b",
        "textVi": "Mời bà con chòm xóm chung vui bữa cơm thân mật tạ ơn",
        "outcomeTextVi": "Không khí xóm làng rộn rã lời ca tiếng cười chúc thọ.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": -15,
        "intellectDelta": 10,
        "relationsDelta": 40
      }
    ]
  },
  {
    "id": "eld_07_spouses_illness_care",
    "stageKey": "elderly",
    "age": 72,
    "titleVi": "Chăm Sóc Bạn Đời Lúc Đau Yếu",
    "descriptionVi": "Người bạn đời bị tai biến nhẹ phải nằm viện điều trị, bạn kiên trì túc trực bên giường bệnh.",
    "category": "love",
    "choices": [
      {
        "id": "eld_07_a",
        "textVi": "Nắm chặt bàn tay bạn đời, tự tay đút từng thìa cháo và đọc kinh an ủi",
        "outcomeTextVi": "Nghĩa tào khang son sắt làm rơi lệ các y bác sĩ trong viện, bạn đời hồi phục kỳ diệu.",
        "healthDelta": -5,
        "happinessDelta": 30,
        "wealthDelta": -20,
        "intellectDelta": 10,
        "relationsDelta": 45,
        "addVirtue": "Thủy chung son sắt chăm sóc bạn đời trọn tình trọn nghĩa đến hơi thở cuối cùng"
      },
      {
        "id": "eld_07_b",
        "textVi": "Cùng các con thay phiên nhau xoa bóp, tập phục hồi chức năng cho bạn đời",
        "outcomeTextVi": "Tình đoàn kết gia đình nâng đỡ người bệnh vượt qua cơn hiểm nghèo.",
        "healthDelta": 0,
        "happinessDelta": 30,
        "wealthDelta": -15,
        "intellectDelta": 10,
        "relationsDelta": 40
      }
    ]
  },
  {
    "id": "eld_08_sacrament_of_reconciliation",
    "stageKey": "elderly",
    "age": 73,
    "titleVi": "Bí Tích Hòa Giải Mùa Chay Tuổi Già",
    "descriptionVi": "Tuổi già bóng xế, bạn đến tòa giải tội xưng thú những lỗi lầm sâu kín và đón nhận ơn Chúa qua Bí Tích Hòa Giải.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "eld_08_a",
        "textVi": "Thành tâm sám hối và mở lòng đón nhận bình an tha thứ của Bí Tích Hòa Giải",
        "outcomeTextVi": "Mọi muộn phiền dĩ vãng tiêu tan, tâm hồn bạn nhẹ nhàng thanh thoát như làn mây trắng.",
        "healthDelta": 15,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 30,
        "addSacrament": "Bí Tích Hòa Giải",
        "addVirtue": "Tâm hồn thanh sạch, sẵn sàng phó thác mọi sự trong tay Chúa"
      },
      {
        "id": "eld_08_b",
        "textVi": "Làm hòa với một người bạn xưa cũ mình từng hiểu lầm nhiều năm trước",
        "outcomeTextVi": "Cái ôm hòa giải cuối đời xóa nhòa mọi vết hằn quá khứ.",
        "healthDelta": 15,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 40
      }
    ]
  },
  {
    "id": "eld_09_bird_watching",
    "stageKey": "elderly",
    "age": 64,
    "titleVi": "Nghe Tiếng Chim Hót & Chăm Sóc Vườn Cây",
    "descriptionVi": "Khu vườn râm mát đầy hoa trái thu hút bầy chim sẻ, chim chích chòe ríu rít chuyền cành.",
    "category": "health",
    "choices": [
      {
        "id": "eld_09_a",
        "textVi": "Treo máng rải thóc cho chim và ngồi ngắm nhìn trong sự tĩnh lặng thanh tao",
        "outcomeTextVi": "Tâm hồn hòa cùng thiên nhiên tạo vật, mọi lo toan bụi bặm trần thế lùi xa.",
        "healthDelta": 20,
        "happinessDelta": 35,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 15
      },
      {
        "id": "eld_09_b",
        "textVi": "Chiết cành tặng hoa phong lan cho các bạn già trong hội sinh vật cảnh",
        "outcomeTextVi": "Thú chơi tao nhã kết nối những tâm hồn đồng điệu tuổi xế chiều.",
        "healthDelta": 15,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "eld_10_traditional_chess_table",
    "stageKey": "elderly",
    "age": 66,
    "titleVi": "Bàn Cờ Chiều Dưới Bóng Cây Đa Làng",
    "descriptionVi": "Mỗi buổi chiều, bạn cùng các cụ già trong làng mang bàn cờ gỗ ra gốc đa so tài mưu lược.",
    "category": "education",
    "choices": [
      {
        "id": "eld_10_a",
        "textVi": "Đi những nước cờ thanh thoát, mỉm cười nhường bạn một quân cờ vui vẻ",
        "outcomeTextVi": "Tiếng cười rộn rã của các cụ già làm sáng bừng cả góc làng quê.",
        "healthDelta": 15,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 35
      },
      {
        "id": "eld_10_b",
        "textVi": "Bình luận thế cờ cho đám trẻ con xúm xít đứng xem xung quanh",
        "outcomeTextVi": "Gieo mầm đam mê cờ truyền thống cho thế hệ măng non.",
        "healthDelta": 10,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "eld_11_charity_bequest",
    "stageKey": "elderly",
    "age": 74,
    "titleVi": "Hiến Tặng Mảnh Đất Cho Trường Mầm Non / Trạm Y Tế",
    "descriptionVi": "Thấy xã thiếu đất xây nhà trẻ kiên cố cho các cháu nhỏ, bạn bàn với gia đình hiến tặng một phần đất vườn.",
    "category": "society",
    "choices": [
      {
        "id": "eld_11_a",
        "textVi": "Tự nguyện hiến tặng 300m2 đất thổ cư xây điểm trường mầm non khang trang",
        "outcomeTextVi": "Hàng trăm em nhỏ có lớp học an toàn, dân làng đời đời ghi ơn tấm lòng bồ tát của bạn.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": -35,
        "intellectDelta": 15,
        "relationsDelta": 50,
        "addVirtue": "Hiến tặng đất đai vì tương lai của thế hệ con em quê hương",
        "unlockAchievement": "Đại Ân Nhân Xóm Làng"
      },
      {
        "id": "eld_11_b",
        "textVi": "Góp thêm chi phí lắp đặt khu vui chơi xích đu, cầu trượt cho các cháu",
        "outcomeTextVi": "Khuôn viên trường tràn ngập tiếng cười khúc khích hồn nhiên.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": -20,
        "intellectDelta": 10,
        "relationsDelta": 40
      }
    ]
  },
  {
    "id": "eld_12_joint_pain_remedy",
    "stageKey": "elderly",
    "age": 67,
    "titleVi": "Chữa Trị Đau Nhức Xương Khớp Mùa Lạnh",
    "descriptionVi": "Gió mùa đông bắc về làm đầu gối và lưng bạn nhức mỏi mỗi khi trở trời.",
    "category": "health",
    "choices": [
      {
        "id": "eld_12_a",
        "textVi": "Ngâm chân nước lá ngải cứu muối gừng ấm mỗi tối trước khi đi ngủ",
        "outcomeTextVi": "Mạch máu lưu thông, cơn đau dịu hẳn và bạn có giấc ngủ sâu trọn vẹn.",
        "healthDelta": 20,
        "happinessDelta": 25,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 10
      },
      {
        "id": "eld_12_b",
        "textVi": "Được con cháu mua tặng máy massage và thảm nhiệt hồng ngoại",
        "outcomeTextVi": "Sự hiếu thảo chăm sóc của con cháu là liều thuốc giảm đau kỳ diệu nhất.",
        "healthDelta": 20,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "eld_13_parish_choir_patron",
    "stageKey": "elderly",
    "age": 71,
    "titleVi": "Bảo Trợ Ca Đoàn & Nhạc Cụ Thánh Ca",
    "descriptionVi": "Bạn tài trợ bộ đàn organ và đồng phục mới cho ca đoàn thiếu nhi giáo xứ phục vụ phụng vụ.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "eld_13_a",
        "textVi": "Tặng đàn organ cao cấp và khuyến khích các em thiếu nhi trau dồi thánh nhạc",
        "outcomeTextVi": "Tiếng đàn thánh thót vang vọng cung thánh nâng đỡ tâm hồn cộng đoàn sốt sắng.",
        "healthDelta": 5,
        "happinessDelta": 40,
        "wealthDelta": -20,
        "intellectDelta": 15,
        "relationsDelta": 35,
        "addVirtue": "Nuôi dưỡng nghệ thuật thánh ca tôn vinh Thiên Chúa"
      },
      {
        "id": "eld_13_b",
        "textVi": "Lắng nghe ca đoàn tập hát vào mỗi tối thứ Bảy",
        "outcomeTextVi": "Những giai điệu du dương xoa dịu tâm hồn bạn sau những năm tháng nhọc nhằn.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "eld_14_peaceful_sleep",
    "stageKey": "elderly",
    "age": 75,
    "titleVi": "Giấc Ngủ Ngon Tuổi Thọ",
    "descriptionVi": "Không vướng bận danh lợi, không oán thù ghen ghét, bạn đặt lưng xuống là ngủ sâu thanh thản.",
    "category": "health",
    "choices": [
      {
        "id": "eld_14_a",
        "textVi": "Dâng lời kinh tạ ơn cuối ngày và phó thác trọn giấc ngủ trong tay Chúa",
        "outcomeTextVi": "Sức khỏe tuổi thọ được duy trì bền bỉ nhờ giấc ngủ an nhiên tuyệt đối.",
        "healthDelta": 25,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 15,
        "addVirtue": "Tâm hồn thảnh thơi thanh thản tuyệt đối trước giấc ngủ"
      },
      {
        "id": "eld_14_b",
        "textVi": "Uống một tách trà hoa cúc mật ong ấm trước khi ngủ",
        "outcomeTextVi": "Cơ thể ấm áp, tâm trí nhẹ nhàng, buổi sớm thức dậy khoan khoái.",
        "healthDelta": 20,
        "happinessDelta": 30,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "eld_15_great_grandchild_born",
    "stageKey": "elderly",
    "age": 78,
    "titleVi": "Đón Chắt Đời Thứ Tư — Tứ Đại Đồng Đường",
    "descriptionVi": "Cháu nội/ngoại sinh con, bạn chính thức lên chức Cụ trong niềm vui vô bờ bến của cả dòng họ.",
    "category": "family",
    "choices": [
      {
        "id": "eld_15_a",
        "textVi": "Đôi bàn tay run run ẵm chắt nhỏ vào lòng và chúc phúc cho bé",
        "outcomeTextVi": "Bức ảnh gia tộc bốn thế hệ quây quần là biểu tượng của hồng ân trường thọ vẹn toàn.",
        "healthDelta": 15,
        "happinessDelta": 50,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 50,
        "unlockAchievement": "Tứ Đại Đồng Đường Viên Mãn"
      },
      {
        "id": "eld_15_b",
        "textVi": "Tặng chắt chiếc vòng bạc gia truyền mà ông bà để lại",
        "outcomeTextVi": "Vật gia bảo nối kết sợi dây tình cảm thiêng liêng giữa các thế hệ.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": -10,
        "intellectDelta": 10,
        "relationsDelta": 45,
        "addVirtue": "Trao truyền vật gia bảo gắn kết tình thân sâu nặng của dòng tộc"
      }
    ]
  },
  {
    "id": "eld_16_passing_of_spouse",
    "stageKey": "elderly",
    "age": 77,
    "titleVi": "Người Bạn Đời Tạ Thế Bình Yên",
    "descriptionVi": "Sau hơn 50 năm gắn bó keo sơn, người bạn đời nhắm mắt xuôi tay an nghỉ trong giấc ngủ ngàn thu.",
    "category": "love",
    "choices": [
      {
        "id": "eld_16_a",
        "textVi": "Hôn lên trán bạn đời lần cuối, cầu nguyện xin Chúa đón nhận linh hồn người thương",
        "outcomeTextVi": "Dù đẫm lệ tiễn đưa nhưng tâm hồn bạn bình an vì biết sẽ sum họp lại nơi Thiên Quốc.",
        "healthDelta": -10,
        "happinessDelta": 0,
        "wealthDelta": -20,
        "intellectDelta": 20,
        "relationsDelta": 45,
        "addVirtue": "Thủy chung trọn nghĩa phu thê, kiên vững đức tin trước sự chia ly sinh tử"
      },
      {
        "id": "eld_16_b",
        "textVi": "Được đàn con cháu vây quanh an ủi, nâng đỡ từng bước chân",
        "outcomeTextVi": "Tình yêu thương của con cháu giúp bạn vơi bớt nỗi cô đơn tuổi già.",
        "healthDelta": 0,
        "happinessDelta": 10,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 45
      }
    ]
  },
  {
    "id": "eld_17_memories_album",
    "stageKey": "elderly",
    "age": 75,
    "titleVi": "Lật Từng Trang Album Ảnh Cuộc Đời",
    "descriptionVi": "Những buổi chiều hanh vàng, bạn cùng con cháu mở lại những cuốn album ảnh từ thời đen trắng.",
    "category": "family",
    "choices": [
      {
        "id": "eld_17_a",
        "textVi": "Kể lại từng kỷ niệm: thời ấu thơ, ngày cưới, lúc sinh con và những chuyến đi xa",
        "outcomeTextVi": "Cả nhà quây quần nghe chuyện trong niềm xúc động, thấu hiểu công lao của thế hệ đi trước.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 40,
        "addVirtue": "Gìn giữ ký ức gia đình và truyền lại bài học nhân sinh quý báu"
      },
      {
        "id": "eld_17_b",
        "textVi": "Cùng cháu quét ảnh số hóa lưu giữ vĩnh viễn trên máy tính",
        "outcomeTextVi": "Di sản hình ảnh của gia đình được bảo tồn vẹn nguyên cho muôn đời sau.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "eld_18_peaceful_solitude",
    "stageKey": "elderly",
    "age": 79,
    "titleVi": "Sự Tĩnh Lặng Trầm Mặc Của Tuổi Già",
    "descriptionVi": "Bạn tìm thấy niềm hoan lạc trong sự thinh lặng, lắng nghe tiếng gió qua rặng tre và tiếng chuông chiều.",
    "category": "faith",
    "choices": [
      {
        "id": "eld_18_a",
        "textVi": "Suy ngẫm về sự hữu hạn của đời người và vẻ đẹp vĩnh cửu của tình thương",
        "outcomeTextVi": "Trí tuệ của bạn đạt tới cảnh giới thông tuệ, không còn sợ hãi cái chết.",
        "healthDelta": 15,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 30,
        "relationsDelta": 20,
        "addVirtue": "Thông tuệ an nhiên, bình thản đón nhận quy luật sinh tử"
      },
      {
        "id": "eld_18_b",
        "textVi": "Lần hạt cầu nguyện cho hòa bình thế giới và những người đang chịu đau khổ",
        "outcomeTextVi": "Lời cầu nguyện thầm lặng của bậc cao niên là ơn phúc che chở cho muôn người.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "eld_19_visiting_old_friends",
    "stageKey": "elderly",
    "age": 69,
    "titleVi": "Gặp Mặt Những Người Bạn Học Thuở Thiếu Thời",
    "descriptionVi": "Sau hơn 50 năm, nhóm bạn học thuở phổ thông còn lại vài cụ tóc bạc phơ gặp lại nhau.",
    "category": "relations",
    "choices": [
      {
        "id": "eld_19_a",
        "textVi": "Nắm chặt tay nhau, mắt ngấn lệ ôn lại kỷ niệm mái trường xưa",
        "outcomeTextVi": "Tình bạn vượt qua nửa thế kỷ thăng trầm sáng ngời như ánh pha lê.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 45
      },
      {
        "id": "eld_19_b",
        "textVi": "Cùng thắp hương tưởng nhớ những người bạn đã ra đi trước",
        "outcomeTextVi": "Nghĩa tình tri kỷ ấm áp, vẹn nguyên lòng thương nhớ.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 40,
        "addVirtue": "Trọn tình vẹn nghĩa với bạn hữu thuở thiếu thời suốt cả một đời"
      }
    ]
  },
  {
    "id": "eld_20_village_elder_blessing",
    "stageKey": "elderly",
    "age": 78,
    "titleVi": "Bậc Trưởng Thượng Ban Lời Huấn Thị",
    "descriptionVi": "Trong ngày hội làng đầu xuân, bạn được mời phát biểu khai mạc chúc Tết toàn thể dân làng.",
    "category": "society",
    "choices": [
      {
        "id": "eld_20_a",
        "textVi": "Cất lời chúc an lành, khuyên bảo thế hệ trẻ giữ gìn đạo đức, cần cù và đoàn kết",
        "outcomeTextVi": "Cả hội làng im phăng phắc lắng nghe rồi vỗ tay vang dội, kính cẩn cúi đầu nhận lời chúc.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 50,
        "addVirtue": "Bậc trưởng thượng nêu gương sáng đạo đức và truyền thừa văn hóa"
      },
      {
        "id": "eld_20_b",
        "textVi": "Tặng chữ thư pháp \"Phúc - Đức - An\" cho các gia đình trẻ",
        "outcomeTextVi": "Nét chữ rồng bay phượng múa được treo trang trọng tại các phòng khách.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": -5,
        "intellectDelta": 20,
        "relationsDelta": 45
      }
    ]
  },
  {
    "id": "eld_21_traditional_herbal_bath",
    "stageKey": "elderly",
    "age": 71,
    "titleVi": "Nồi Nước Lá Xông Cổ Truyền Cuối Năm",
    "descriptionVi": "Chiều 30 Tết, con cháu đun nồi nước lá mùi già thơm ngát cho bạn tắm tất niên thanh sạch.",
    "category": "health",
    "choices": [
      {
        "id": "eld_21_a",
        "textVi": "Tận hưởng hương thơm dân dã ấm áp, xua tan mọi mỏi mệt tuổi già",
        "outcomeTextVi": "Cơ thể sảng khoái nhẹ nhõm, sẵn sàng đón mừng năm mới an khang.",
        "healthDelta": 20,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 25
      },
      {
        "id": "eld_21_b",
        "textVi": "Dạy con cháu bí quyết phối hợp các loại thảo dược tự nhiên",
        "outcomeTextVi": "Nét đẹp phong tục cổ truyền được gìn giữ trong tổ ấm.",
        "healthDelta": 15,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "eld_22_forgiving_old_debts",
    "stageKey": "elderly",
    "age": 75,
    "titleVi": "Xóa Nợ Cho Người Khó Khăn",
    "descriptionVi": "Tìm lại cuốn sổ nợ năm xưa, nhiều người nghèo từng vay tiền bạn làm ăn nhưng gặp trắc trở chưa trả được.",
    "category": "society",
    "choices": [
      {
        "id": "eld_22_a",
        "textVi": "Đốt bỏ toàn bộ giấy nợ, nhắn lời nhắn xá nợ hoàn toàn cho mọi người",
        "outcomeTextVi": "Tấm lòng bồ tát cứu vớt nhiều gia đình khỏi gánh nặng tâm lý, bạn cảm nhận sự nhẹ nhõm vô bờ.",
        "healthDelta": 10,
        "happinessDelta": 50,
        "wealthDelta": -30,
        "intellectDelta": 20,
        "relationsDelta": 45,
        "addVirtue": "Khoan dung xóa nợ cho người nghèo khó theo lời dạy của Tin Mừng",
        "unlockAchievement": "Đại Lượng Bao Dung"
      },
      {
        "id": "eld_22_b",
        "textVi": "Cầu chúc họ làm ăn phát đạt, sống bình an bên gia đình",
        "outcomeTextVi": "Lòng nhân hậu của bạn để lại tiếng thơm muôn đời cho con cháu.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 40
      }
    ]
  },
  {
    "id": "eld_23_grandpa_chess_champion",
    "stageKey": "elderly",
    "age": 72,
    "titleVi": "Kỳ Thủ Cao Tuổi Nhất Hội Làng",
    "descriptionVi": "Bạn tham gia giải cờ người đầu xuân, điều khiển quân cờ với phong thái ung dung tự tại.",
    "category": "education",
    "choices": [
      {
        "id": "eld_23_a",
        "textVi": "Đi những nước cờ hoa mỹ, hòa ván cờ giao hữu đẹp mắt với kỳ thủ trẻ",
        "outcomeTextVi": "Khán giả trầm trồ vỗ tay tán thưởng phong thái cờ đạo cao thượng.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": 5,
        "intellectDelta": 25,
        "relationsDelta": 35
      },
      {
        "id": "eld_23_b",
        "textVi": "Tặng bộ cờ gỗ quý cho kỳ thủ trẻ triển vọng nhất giải",
        "outcomeTextVi": "Sự khích lệ của bậc tiền bối tiếp thêm ngọn lửa đam mê cho thế hệ sau.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": -10,
        "intellectDelta": 15,
        "relationsDelta": 35,
        "addVirtue": "Nâng đỡ và trao truyền ngọn lửa trí tuệ cho thế hệ trẻ"
      }
    ]
  },
  {
    "id": "eld_24_pilgrimage_fatima_lourdes",
    "stageKey": "elderly",
    "age": 76,
    "titleVi": "Hành Hương Đức Mẹ Lộ Đức / Fatima",
    "descriptionVi": "Chuyến hành hương cuối cùng đến suối nguồn ơn lạ Lộ Đức múc nước thánh tạ ơn.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "eld_24_a",
        "textVi": "Uống dòng nước thánh Lộ Đức và cầu nguyện xin ơn chết lành trong tay Chúa",
        "outcomeTextVi": "Tâm hồn bạn tràn ngập ân sủng kỳ diệu, mọi sợ hãi về bệnh tật hoàn toàn biến mất.",
        "healthDelta": 20,
        "happinessDelta": 45,
        "wealthDelta": -25,
        "intellectDelta": 20,
        "relationsDelta": 30,
        "addVirtue": "Phó thác trọn vẹn sự sống và sự chết trong tình thương Đức Mẹ"
      },
      {
        "id": "eld_24_b",
        "textVi": "Mang nước thánh về làm quà tặng bà con người bệnh trong xứ",
        "outcomeTextVi": "Món quà thiêng liêng nâng đỡ đức tin cho nhiều bệnh nhân đau yếu.",
        "healthDelta": 15,
        "happinessDelta": 40,
        "wealthDelta": -10,
        "intellectDelta": 15,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "eld_25_age80_milestone",
    "stageKey": "elderly",
    "age": 80,
    "titleVi": "Bát Thập Đại Thọ — Tròn 80 Mùa Xuân",
    "descriptionVi": "Tròn 80 tuổi, mái tóc bạc như cước, nụ cười hiền hậu, bạn được con cháu tổ chức lễ đại thọ trọng thể.",
    "category": "family",
    "choices": [
      {
        "id": "eld_25_a",
        "textVi": "Mỉm cười nắm tay từng đứa cháu chắt, dặn dò giữ lấy chữ Tâm và chữ Đức",
        "outcomeTextVi": "Gia đình tứ đại đồng đường rạng rỡ phúc lộc, con cháu quỳ gối chúc thọ xúc động.",
        "healthDelta": 15,
        "happinessDelta": 50,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 50,
        "addVirtue": "Đại thọ viên mãn, để lại tấm gương đạo đức sáng ngời cho đàn con cháu",
        "unlockAchievement": "Bát Thập Đại Thọ Viên Mãn"
      },
      {
        "id": "eld_25_b",
        "textVi": "Dâng Thánh Lễ tạ ơn Thiên Chúa vì 80 năm tràn trề hồng ân sự sống",
        "outcomeTextVi": "Tâm hồn ngập tràn ánh sáng tạ ơn, thanh thản bước sang tuổi đại thọ.",
        "healthDelta": 15,
        "happinessDelta": 45,
        "wealthDelta": -10,
        "intellectDelta": 20,
        "relationsDelta": 45
      }
    ]
  },
  {
    "id": "eld_26_peaceful_heart",
    "stageKey": "elderly",
    "age": 80,
    "titleVi": "Tâm Không Vướng Bận — Sẵn Sàng Về Nguồn",
    "descriptionVi": "Mọi bổn phận trần thế đã hoàn thành trọn vẹn, bạn sống từng ngày trong sự biết ơn sâu xa.",
    "category": "faith",
    "choices": [
      {
        "id": "eld_26_a",
        "textVi": "Ngồi bên hiên nhà ngắm ánh hoàng hôn buông xuống trong niềm an lạc tuyệt đối",
        "outcomeTextVi": "Một đời sống trọn vẹn, không oán hận, không tiếc nuối, tràn đầy tình thương.",
        "healthDelta": 15,
        "happinessDelta": 50,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 35,
        "addVirtue": "Tâm an như nước mùa thu, hoàn thành trọn vẹn sứ mạng một kiếp nhân sinh"
      },
      {
        "id": "eld_26_b",
        "textVi": "Chúc bình an cho từng người thân yêu mỗi tối",
        "outcomeTextVi": "Tình yêu thương lan tỏa sưởi ấm toàn bộ mái ấm gia đình.",
        "healthDelta": 15,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 45
      }
    ]
  }
];
